<template>
  <div data-v-7b1e8ab4="" data-v-011e1fb8="" class="agJackpot2022 mainContent top50" v-if="dataInfo.title">
    <img :src="dataInfo.banner" alt="" />
    <img data-v-7b1e8ab4="" @click="doactivityapply" style="margin: 50px auto; display: block; cursor: pointer" src="https://91a2c0front.codjiangxilao.com/cdn/91a2c0FNEW/static/img/button_red.d506ae4e.png" />
    <img data-v-7b1e8ab4="" style="margin: 20px auto; display: block" src="https://91a2c0front.codjiangxilao.com/cdn/91a2c0FNEW/static/img/title_2.c4a6a1b3.png" />
    <div class="infoBoxz">
      <div class="tit">{{ dataInfo.title }}</div>
      <div v-html="dataInfo.content"></div>
      <div v-html="dataInfo.memo"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'discountInfo',
  data() {
    return { dataInfo: {} };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.showTost(1, res.message);
        that.$parent.hideLoading();

      });
    },
    getInfo(id) {
      let that = this;
      that.$parent.showLoading()
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading()

      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading()
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.hideLoading()
        that.$parent.showTost(1, res.message);

      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-6cc178e1.70a3ba40.css';
@import '../../../static/css/chunk-009dfcc3.a4bf2976.css';
@import '../../../static/css/chunk-1225a5b6.b06a16a7.css';
@import '../../../static/css/chunk-639bacf2.80f975ef.css';
@import '../../../static/css/chunk-1bfc786f.3344e98f.css';
@import '../../../static/css/chunk-9c01ee94.ae6edd11.css';
@import '../../../static/css/chunk-4a9bbb2b.cbe5dff6.css';
.faq .faq-container .row .group .a-row[data-v-3ecdc100] {
  display: none;
}
.infoBoxz {
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  padding: 50px;
}
.tit {
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  height: 60px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/allMode/discountInfo.vue